module.exports = __webpack_public_path__ + "static/img/comelogo.070462ec.png";